import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import Vue from "vue";
import App from "@/App";
import store from "@/store";
import router from "@/router";

import "@/plugins/element";
import "@/plugins/i18n";
import "@/plugins/axios";
import "@/plugins/filters";
import "@/plugins/lazyload";
import "@/plugins/socket";
// import "@/plugins/jsstozip.ext";

import "normalize.css/normalize.css"; // a modern alternative to CSS resets
import "@/styles/index.scss"; // global css
import "@/icons"; // icon
import "@/permission"; // permission control
import "github-markdown-css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
